import { useState, useEffect } from 'react'
import { BillListItemFragment, useDepositDocumentsQuery, useBillsListQuery } from 'src/api/api.generated'
import { useTenant } from 'src/app/hooks/context/context.hook'
import useErrorSnackBar from 'src/app/hooks/error-snack-bar/error-snack-bar'

export default function useAccountBalanceReportCrud(billIds: string[]) {
  const { id: tenantId } = useTenant()
  const showError = useErrorSnackBar()
  const [depositAssignedIds, setDepositAssignedIds] = useState<string[] | null>(null)

  const [bills, setBills] = useState<BillListItemFragment[]>([])
  const { loading: loadingBill, refetch: refetchBills } = useBillsListQuery({
    skip: true,
  })

  useEffect(() => {
    const fetchData = async () => {
      if (billIds.length) {
        const billsResult = await refetchBills({
          filter: {
            tenantId: {
              eq: tenantId,
            },
            id: { in: billIds },
          },
        })
        if (billsResult.data && !billsResult.error) {
          setBills(billsResult.data.bills ?? [])
        } else {
          showError(billsResult.error)
        }
      }
    }
    fetchData()
  }, [JSON.stringify(billIds), refetchBills])

  const { loading: loadingDeposits, refetch: refetchDeposits } = useDepositDocumentsQuery({
    skip: true,
  })

  useEffect(() => {
    const reservationIds = bills.map((bill) => bill.reservationId ?? []).flat()
    if (reservationIds && reservationIds.length > 0) {
      const fetchData = async () => {
        const tmpDepositAssignedIds: string[] = []
        await Promise.all(
          reservationIds.map(async (resId) => {
            const data = await refetchDeposits({
              filter: {
                reservationId: resId,
                tenantId: {
                  eq: tenantId,
                },
              },
            })
            if (data.data && !data.error) {
              for (const deposit of data.data.depositDocuments ?? []) {
                tmpDepositAssignedIds.push(...(deposit.depositAssigneds ?? []).map((depositAssigned) => depositAssigned.id))
              }
            } else {
              showError(data.error)
            }
          }),
        )
        setDepositAssignedIds(tmpDepositAssignedIds)
      }
      fetchData()
    }
  }, [JSON.stringify(bills), refetchDeposits])

  return { loading: loadingDeposits || loadingBill, depositAssignedIds }
}
